/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GuidIdCodeAndLabel
 */
export interface GuidIdCodeAndLabel {
    /**
     * 
     * @type {string}
     * @memberof GuidIdCodeAndLabel
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GuidIdCodeAndLabel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GuidIdCodeAndLabel
     */
    label?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GuidIdCodeAndLabel
     */
    effective?: boolean;
}

export function GuidIdCodeAndLabelFromJSON(json: any): GuidIdCodeAndLabel {
    return GuidIdCodeAndLabelFromJSONTyped(json, false);
}

export function GuidIdCodeAndLabelFromJSONTyped(json: any, ignoreDiscriminator: boolean): GuidIdCodeAndLabel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'effective': !exists(json, 'effective') ? undefined : json['effective'],
    };
}

export function GuidIdCodeAndLabelToJSON(value?: GuidIdCodeAndLabel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'id': value.id,
        'label': value.label,
        'effective': value.effective,
    };
}


